import React from 'react'
import reactStamp from 'react-stamp'
import GroupItem from "./GroupItem"
import FlatButton from 'material-ui/FlatButton';
import Add from 'material-ui/svg-icons/content/add';
import './health.css'

export default reactStamp(React).compose({

    init(){
        this.getRows = this.getRows.bind(this);
        this.addNew = this.addNew.bind(this);
        this.removeGroupItem = this.removeGroupItem.bind(this);
        this.state.data = this.props.data;
    },

    componentWillReceiveProps(nextProps) {
        this.setState({
            data: nextProps.data,
        });
    },

    state: {
        data: "",
        addNew: false
    },

    render() {
        return (
            <div className="group-container">
                <h2 className="group-title">{this.props.title}</h2>
                <p className="group-description">{this.props.description}</p>
                <div className="table-header">
                    <h2 className="head-title">{this.props.type}</h2>
                    <h2 className="head-title">date</h2>
                </div>
                {this.getContent(this.props.editMode)}
            </div>
        )
    },

    getRows(){
        let _items = [];
        let index = 0;
        let rowNumber = 1;
        
        for (let item of this.props.data) {
            if (item.status == "true") {
                rowNumber++
            }
        }
        for (let item of this.props.data) {
            if (item.status == "true") {
                _items.push(
                    <GroupItem
                        type={this.props.type}
                        key={index++}
                        id={item.id}
                        name={item.name}
                        onsetDate={item.onsetDate}
                        otherData={this.props.data}
                        handleNameChange={this.props.handleNameChange}
                        handleDateChange={this.props.handleDateChange}
                        rowNumber={item.rowNumber || rowNumber}
                        removeGroupItem={this.removeGroupItem}
                    />
                );
                rowNumber++;
            }
        }
        
        _items.sort((a, b) => {
            return (a.props.rowNumber - b.props.rowNumber)
        })

        return _items;
    },

    getNonEditableRows(){
        let _items = [];

        for (let item of this.props.data) {
            if (item.status == "true") {
                _items.push(
                    <div>
                        <div className="table-header">
                            <p className="select-field">{item.name}</p>
                            <p className="select-field">{item.onsetDate}</p>
                        </div>
                        <div className="divider-light"></div>
                    </div>
                )
            }
        }
        
        return _items;
    },

    addNew(){
        this.props.createNew(this.props.type);
    },

    removeGroupItem(item){
        this.props.removeGroupItem(item, this.props.type);
    },

    getContent(editMode){
        if (editMode) {
            return (
                <div>
                    <div className="divider"></div>
                    {this.getRows()}
                    <FlatButton
                        className="add-button"
                        label="Add new"
                        primary={true}
                        icon={<Add />}
                        onTouchTap={this.addNew}
                    />
                </div>
            )
        } else {
            return (
                <div>
                    <div className="divider"></div>
                    {this.getNonEditableRows()}
                </div>
            )
        }
    }

});


/** WEBPACK FOOTER **
 ** ./src/app/components/Health/Group.js
 **/